module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('email-cobranca-view', {
    ref: "cobrancaView"
  }), _vm._v(" "), _c('email-automatico-view', {
    ref: "emailAutomaticoView"
  }), _vm._v(" "), _c('copiar-lotes-view', {
    ref: "copiarLotesView"
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(_vm.leilao !== null) ? _c('div', {
    staticClass: "content-transition"
  }, [_c('btn-status-confirmar', {
    ref: "confirmarStatus",
    attrs: {
      "Status": _vm.getStatus
    }
  }), _vm._v(" "), _c('grafico-leilao-dash', {
    staticClass: "hidden-print"
  }), _vm._v(" "), _c('div', {
    staticClass: "fade-in-down"
  }, [_c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "m-b"
  }, [(_vm.leilao.status === _vm.Status.STATUS_ENCERRADO) ? _c('u-button-group', {
    staticClass: "m-b pull-right",
    attrs: {
      "options": _vm.visibilityOptions
    },
    on: {
      "change": _vm.alterarVisibilidadeNaHome
    },
    model: {
      value: (_vm.leilao.forcarAparecerNaHome),
      callback: function($$v) {
        _vm.$set(_vm.leilao, "forcarAparecerNaHome", $$v)
      },
      expression: "leilao.forcarAparecerNaHome"
    }
  }) : _vm._e(), _vm._v(" "), _c('h1', {
    staticClass: "m-n font-thin h3"
  }, [_vm._v(_vm._s(_vm.leilao.titulo))]), _vm._v(" "), _c('span', {
    staticClass: "label no-radius bg-dark"
  }, [_vm._v(_vm._s(_vm.leilao.categoria ? _vm.leilao.categoria.nome : 'Sem Categoria'))]), _vm._v(" "), _c('span', {
    staticClass: "label m-l-n-xxs no-radius bg-success "
  }, [_vm._v(_vm._s(_vm.HelperTipo(_vm.leilao.tipo)))]), _vm._v(" "), (_vm.leilao.leilaoJudicial) ? _c('span', {
    staticClass: "label m-l-n-xxs no-radius bg-warning"
  }, [_vm._v("Judicial")]) : _vm._e(), _vm._v(" "), (_vm.leilao.loteado) ? _c('span', {
    staticClass: "label m-l-n-xxs no-radius bg-primary"
  }, [_vm._v("Loteado")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('btn-controle', {
    attrs: {
      "leilao": _vm.leilao,
      "ACL": _vm.ACL,
      "currentUser": _vm.currentUser
    }
  }), _vm._v(" "), _c('btn-edital', {
    attrs: {
      "leilao": _vm.leilao,
      "ACL": _vm.ACL,
      "currentUser": _vm.currentUser
    }
  }), _vm._v(" "), _c('btn-acoes-planilhas-leilao', {
    on: {
      "gerarPlanilhaExtratoLeilao": _vm.gerarPlanilhaExtratoLeilao,
      "gerarPlanilha005": _vm.gerarPlanilha005,
      "gerarPlanilhaNotas": _vm.gerarPlanilhaNotasLeilao
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 text-right"
  }, [(_vm.ACL.check('alterar_status_leilao', _vm.currentUser.id)) ? _c('btn-status', {
    staticClass: "hidden-print",
    attrs: {
      "Status": _vm.getStatus,
      "value": _vm.leilao.status
    },
    on: {
      "input": _vm.confirmarAlteracaoStatus
    }
  }) : _vm._e(), _vm._v(" "), _c('u-button', {
    staticClass: "btn btn-sm btn-info hidden-print",
    attrs: {
      "tabindex": "1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.print($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print m-r-xs"
  }), _vm._v(" Imprimir\n              ")]), _vm._v(" "), _c('btn-relatorios', {
    staticClass: "hidden-print",
    attrs: {
      "leilao": _vm.leilao
    }
  }), _vm._v(" "), (!_vm.isRestritoVisitante) ? _c('btn-acoes', {
    attrs: {
      "leilao": _vm.leilao
    },
    on: {
      "renovarCache": _vm.renovarCache,
      "emailsAutomaticos": function($event) {
        return _vm.$refs.emailAutomaticoView.load(_vm.leilao.id)
      },
      "updateTransmissaoUrl": _vm.updateTransmissaoUrl,
      "gerarArquivoRemessa": _vm.gerarArquivoRemessa
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isRestritoVisitante) ? _c('u-button', {
    staticClass: "btn btn-sm btn-default hidden-print",
    attrs: {
      "tabindex": "1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.editar($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-edit m-r-xs"
  }), _vm._v(" Editar\n              ")]) : _vm._e(), _vm._v(" "), (_vm.podeExcluir && !_vm.isRestritoVisitante) ? _c('u-button', {
    staticClass: "btn btn-sm btn-danger hidden-print",
    attrs: {
      "tabindex": "1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.excluir($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash m-r-xs"
  }), _vm._v(" Excluir\n              ")]) : _vm._e()], 1)]), _vm._v(" "), (_vm.ENV_INFRA === 'local') ? _c('div', {
    staticClass: "m-t"
  }, [(!_vm.sync) ? _c('u-button', {
    on: {
      "click": _vm.sincronizarLeilaoLocal
    }
  }, [_c('i', {
    staticClass: "fa fa-terminal m-r-xs"
  }), _vm._v(" Iniciar transição para leilão local\n            ")]) : _vm._e(), _vm._v(" "), (_vm.sync) ? _c('shell-sync', {
    attrs: {
      "shellResponse": _vm.shellResponse
    }
  }) : _vm._e()], 1) : _c('div', {
    staticClass: "m-t"
  }, [_vm._v("\n            Online...\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("assets/img/leilaoico.png"),
      "height": "40"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('h4', [_vm._v(_vm._s(_vm.leilao.resumo))]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": 'https://www.aplleiloes.com.br/leilao/' + _vm.leilao.id
    }
  }, [_vm._v("www.aplleiloes.com.br/leilao/" + _vm._s(_vm.leilao.id))])]), _vm._v(" "), _c('p', [_vm._v("\n                  Publicação: "), _c('strong', [_vm._v(_vm._s(_vm.moment(_vm.leilao.dataPublicacao.date).format('LLLL')))]), _vm._v(" "), _c('br'), _vm._v("\n                  Abertura: "), _c('strong', [_vm._v(_vm._s(_vm.moment(_vm.leilao.dataAbertura.date).format('LLLL')))]), _vm._v(" "), (_vm.leilao.autoFechamento) ? _c('span', {
    staticClass: "label bg-dark"
  }, [_vm._v("Automático")]) : _vm._e()]), _vm._v(" "), (_vm.leilao.tipo !== 1) ? _c('p', [_vm._v("Tempo do Pregão: "), _c('strong', [_vm._v(_vm._s(_vm.leilao.timerPregao) + " segundos")])]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("Porcentagem de cobrança: "), _c('strong', [_vm._v(_vm._s(+_vm.leilao.porcentagemCobranca) + "% do valor do arremate")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 text-right"
  }, [_c('p', {
    staticClass: "h4"
  }, [_vm._v("#" + _vm._s(_vm.leilao.id))]), _vm._v(" "), _c('h5', [_vm._v("Criado " + _vm._s(_vm.moment(_vm.leilao.dataCadastro.date).calendar()))]), _vm._v(" "), _c('p', {
    staticClass: "m-t m-b"
  }, [_vm._v("\n                  Leilão Interno: "), _c('strong', [_vm._v(_vm._s(_vm.leilao.syncExtra ? _vm.leilao.syncExtra.codigoInterno : ''))]), _c('br'), _vm._v("\n                  ID Interno: "), _c('strong', [_vm._v("#" + _vm._s(_vm.leilao.syncId))])])])]), _vm._v(" "), _c('div', {
    staticClass: "well m-t bg-light lt"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('strong', [_vm._v("LEILOEIRO:")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.leilao.leiloeiro ? _vm.leilao.leiloeiro.pessoa.nome : 'Sem leiloeiro definido'))]), _vm._v(" "), _c('p', [(_vm.leilao.comissao) ? _c('span', [_vm._v("Comissão: " + _vm._s(_vm.leilao.comissao) + "% "), (_vm.leilao.cobraComissao) ? _c('span', {
    staticClass: "label bg-light"
  }, [_vm._v("Será cobrado")]) : _vm._e(), _c('br')]) : _vm._e()]), _vm._v(" "), (_vm.leilao.local) ? _c('div', [_c('strong', [_vm._v("LOCAL:")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.leilao.local.nome))]), _vm._v(" "), _c('p', [_vm._v("\n                      " + _vm._s(_vm.leilao.local.descricao)), _c('br')])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('strong', [_vm._v("INFORMAÇÕES:")]), _vm._v(" "), _c('p', [_vm._v("\n                    Visitação: " + _vm._s(_vm.leilao.infoVisitacao)), _c('br'), _vm._v("\n                    Retirada: " + _vm._s(_vm.leilao.infoRetirada)), _c('br'), _vm._v("\n                    Observações: " + _vm._s(_vm.leilao.observacao)), _c('br')])])])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), (!_vm.isLeilaoPreparado && !(_vm.grvsAptas && _vm.grvsAptas.length)) ? _c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.isNenhumLoteGerado) ? _c('div', {
    staticClass: "text-center"
  }, [_c('span', {
    staticClass: "alert alert-danger"
  }, [_c('strong', [_vm._v("Atenção: ")]), _vm._v("Nenhum lote foi gerado\n                  ")])]) : (_vm.importadoPorCsvPlacas) ? _c('div', {
    staticClass: "text-center"
  }, [_c('div', [_c('span', {
    staticClass: "alert alert-danger"
  }, [_c('strong', [_vm._v("Atenção: ")]), _vm._v("Nenhum lote foi gerado\n                    "), _c('u-button', {
    staticClass: "btn btn-sm btn-info hidden-print m-l",
    on: {
      "click": _vm.openResultadoImportacaoCsvGrv
    }
  }, [_vm._v("\n                      Relatório da importação\n                    ")])], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "preparar-leilao"
  }, [_vm._v("\n                Selecione o órgão:\n                "), _c('u-button-group', {
    staticClass: "m-r",
    attrs: {
      "options": _vm.tipoProcessos
    },
    model: {
      value: (_vm.tipoProcesso),
      callback: function($$v) {
        _vm.tipoProcesso = $$v
      },
      expression: "tipoProcesso"
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n                Somente veículos no pátio há:\n                "), _c('u-button-group', {
    staticClass: "m-r",
    attrs: {
      "options": _vm.diasVeiculoNoPatioOptions
    },
    model: {
      value: (_vm.diasVeiculoNoPatio),
      callback: function($$v) {
        _vm.diasVeiculoNoPatio = $$v
      },
      expression: "diasVeiculoNoPatio"
    }
  }), _vm._v(" "), _c('u-button', {
    staticClass: "btn btn-lg btn-danger hidden-print m-t",
    on: {
      "click": _vm.prepararLeilao
    }
  }, [_vm._v("\n                  Preparar leilão\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "m"
  }, [_vm._v("ou")]), _vm._v(" "), _c('u-button', {
    staticClass: "btn btn-md btn-success hidden-print",
    on: {
      "click": _vm.forceCadastrarManual
    }
  }, [_vm._v("\n                  Cadastrar lotes manualmente\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "m"
  }, [_vm._v("ou")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "inputCsvPlacas",
    attrs: {
      "type": "file",
      "accept": ".csv"
    },
    on: {
      "change": _vm.prepararLeilaoComCsvDePlacas
    }
  }), _vm._v(" "), _c('u-button', {
    staticClass: "btn btn-md btn-success hidden-print",
    on: {
      "click": function($event) {
        return _vm.$refs.inputCsvPlacas.click()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" Importar csv com GRVs para preparar o leilão\n                ")])], 1)]) : (!_vm.isLeilaoPreparado) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-3"
  }, [_c('h4', [_vm._v("GRVs Aptas para o Leilão "), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.filteredDataGrvs && _vm.filteredDataGrvs.length))])])]), _vm._v(" "), (!_vm.importadoPorCsvPlacas) ? _c('div', {
    staticClass: "col-xs-4"
  }, [_c('u-button-group', {
    staticClass: "m-r",
    attrs: {
      "options": _vm.diasVeiculoNoPatioOptions
    },
    model: {
      value: (_vm.diasVeiculoNoPatio),
      callback: function($$v) {
        _vm.diasVeiculoNoPatio = $$v
      },
      expression: "diasVeiculoNoPatio"
    }
  }), _vm._v(" "), _c('u-button', {
    staticClass: "btn btn-sm btn-danger hidden-print",
    on: {
      "click": _vm.prepararLeilao
    }
  }, [_vm._v("\n                  Preparar leilão\n                ")])], 1) : _c('div', {
    staticClass: "col-xs-4"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('div', [_c('small', [_vm._v("\n                      Placas inválidas: " + _vm._s(_vm.importacaoCsvPlacas.grvsInvalidas.length) + " "), _c('br'), _vm._v("\n                      Placas não encontradas: " + _vm._s(_vm.importacaoCsvPlacas.grvsNaoEncontradas.length) + "\n                    ")])]), _vm._v(" "), _c('u-button', {
    staticClass: "btn btn-sm btn-success hidden-print m-l",
    on: {
      "click": _vm.openResultadoImportacaoCsvGrv
    }
  }, [_vm._v("\n                    Relatório da importação\n                  ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-5"
  }, [_c('div', {
    staticClass: "pull-right w-md"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterKey),
      expression: "filterKey"
    }],
    staticClass: "input-sm form-control hidden-print",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisar"
    },
    domProps: {
      "value": (_vm.filterKey)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterKey = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pull-right m-r-sm"
  }, [_c('button', {
    staticClass: "btn-sm btn-danger",
    on: {
      "click": _vm.closeLeilaoPreparado
    }
  }, [_vm._v("Cancelar")])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right m-r-sm"
  }, [_c('u-button', {
    staticClass: "btn btn-sm btn-info pull-left hidden-print m-b-sm",
    attrs: {
      "disabled": !_vm.grvsChecked.length
    },
    on: {
      "click": _vm.montarLotesParaLeilaoIndividualmente
    }
  }, [_vm._v("\n                    Gerar lotes com itens selecionados\n                  ")])], 1)])]) : _vm._e(), _vm._v(" "), (!_vm.isLeilaoPreparado && (_vm.grvsAptas && _vm.grvsAptas.length)) ? _c('table', {
    staticClass: "table-lotes-leilao table table-clicked table-striped bg-white b-a"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "hidden-print",
    staticStyle: {
      "width": "30px"
    }
  }, [_c('label', {
    staticClass: "i-checks m-b-none"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedAll),
      expression: "checkedAll"
    }],
    attrs: {
      "type": "checkbox",
      "tabindex": "0",
      "aria-checked": "false",
      "aria-invalid": "false"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkedAll) ? _vm._i(_vm.checkedAll, null) > -1 : (_vm.checkedAll)
    },
    on: {
      "click": _vm.checkAllGrvs,
      "change": function($event) {
        var $$a = _vm.checkedAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkedAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkedAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkedAll = $$c
        }
      }
    }
  }), _c('i')])]), _vm._v(" "), _c('th', {
    staticClass: "text-nowrap",
    class: {
      active: _vm.sortKey === 'numero'
    },
    staticStyle: {
      "width": "60px"
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('numero')
      }
    }
  }, [_vm._v("\n                  GRV "), _c('i', {
    staticClass: "fa",
    class: _vm.sortOrders['numero'] > 0 ? 'fa-caret-down' : 'fa-caret-up',
    staticStyle: {
      "font-size": "10px"
    }
  })]), _vm._v(" "), _c('th', {
    staticClass: "text-nowrap",
    class: {
      active: _vm.sortKey === 'placa'
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('placa')
      }
    }
  }, [_vm._v("\n                  Placa "), _c('i', {
    staticClass: "fa",
    class: _vm.sortOrders['placa'] > 0 ? 'fa-caret-down' : 'fa-caret-up',
    staticStyle: {
      "font-size": "10px"
    }
  })]), _vm._v(" "), _c('th', {
    staticClass: "text-nowrap",
    class: {
      active: _vm.sortKey === 'placaOriginal'
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('placaOriginal')
      }
    }
  }, [_vm._v("\n                  Placa Original "), _c('i', {
    staticClass: "fa",
    class: _vm.sortOrders['placaOriginal'] > 0 ? 'fa-caret-down' : 'fa-caret-up',
    staticStyle: {
      "font-size": "10px"
    }
  })]), _vm._v(" "), _c('th', {
    staticClass: "text-nowrap",
    class: {
      active: _vm.sortKey === 'chassi'
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('chassi')
      }
    }
  }, [_vm._v("\n                  Chassi "), _c('i', {
    staticClass: "fa",
    class: _vm.sortOrders['chassi'] > 0 ? 'fa-caret-down' : 'fa-caret-up',
    staticStyle: {
      "font-size": "10px"
    }
  })]), _vm._v(" "), _c('th', {
    staticClass: "text-nowrap",
    class: {
      active: _vm.sortKey === 'chassi'
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('chassi')
      }
    }
  }, [_vm._v("\n                  Status "), _c('i', {
    staticClass: "fa",
    class: _vm.sortOrders['status'] > 0 ? 'fa-caret-down' : 'fa-caret-up',
    staticStyle: {
      "font-size": "10px"
    }
  })]), _vm._v(" "), _c('th', {
    staticClass: "text-nowrap",
    class: {
      active: _vm.sortKey === 'statusLote'
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('statusLote')
      }
    }
  }, [_vm._v("\n                  Ultimo leilão "), _c('i', {
    staticClass: "fa",
    class: _vm.sortOrders['statusLote'] > 0 ? 'fa-caret-down' : 'fa-caret-up',
    staticStyle: {
      "font-size": "10px"
    }
  })]), _vm._v(" "), _c('th', {
    staticClass: "hidden-print"
  })])]), _vm._v(" "), (_vm.filteredDataGrvs && _vm.filteredDataGrvs.length) ? _c('tbody', _vm._l((_vm.filteredDataGrvs), function(grv) {
    return _c('tr', {
      staticClass: "leilao-list-lote-item"
    }, [_c('td', {
      staticClass: "hidden-print"
    }, [_c('label', {
      staticClass: "i-checks m-b-none"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (grv.checked),
        expression: "grv.checked"
      }],
      attrs: {
        "type": "checkbox",
        "tabindex": "0",
        "aria-checked": "false",
        "aria-invalid": "false"
      },
      domProps: {
        "checked": Array.isArray(grv.checked) ? _vm._i(grv.checked, null) > -1 : (grv.checked)
      },
      on: {
        "click": function($event) {
          return _vm.checkGrv(grv)
        },
        "change": function($event) {
          var $$a = grv.checked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(grv, "checked", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(grv, "checked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(grv, "checked", $$c)
          }
        }
      }
    }), _c('i')])]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: _vm.urlGrv,
          params: {
            id: grv.id
          }
        },
        "target": "_blank",
        "replace": ""
      }
    }, [_c('u', [_vm._v(_vm._s(grv.numero || '-'))])])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(grv.placa))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(grv.placaOriginal))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(grv.chassi))]), _vm._v(" "), _c('td', {
      attrs: {
        "tabindex": "0"
      }
    }, [_c('span', {
      style: ('color: ' + _vm.grvStatusTitle(grv.status, 'color'))
    }, [_vm._v(_vm._s(_vm.grvStatusTitle(grv.status)))])]), _vm._v(" "), _c('td', {
      attrs: {
        "tabindex": "0"
      }
    }, [(grv.statusLote !== null) ? _c('span', [_vm._v(_vm._s(_vm.loteStatus(grv.statusLote).titulo))]) : _c('span', {
      staticStyle: {
        "color": "green"
      }
    }, [_vm._v("Não leiloado")])])])
  }), 0) : _c('tbody', [_c('tr', {
    staticClass: "leilao-list-lote-item"
  }, [_c('td', {
    staticClass: "hidden-print text-center",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("Nada encontrado")])])])]) : _vm._e(), _vm._v(" "), (_vm.isLeilaoPreparado) ? _c('div', {
    staticClass: "row m-b-md"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('btn-acoes-complementares-preparacao-leilao', {
    staticClass: "pull-right",
    on: {
      "forcarOutraImportacao": _vm.forcarOutraImportacao,
      "importacaoSecundaria": function($event) {
        return _vm.$refs.inputImportacaoSecundaria.click()
      }
    }
  }), _vm._v(" "), _c('btn-relatorios-preparacao-leilao', {
    staticClass: "pull-right m-r-sm",
    on: {
      "openResultadoGeracaoLotes": _vm.openResultadoGeracaoLotes,
      "openResultadoImportacaoCsvGrv": _vm.openResultadoImportacaoCsvGrv,
      "openResultadoImportacaoSecundaria": _vm.openResultadoImportacaoSecundaria,
      "openResultadoExportacaoDestinatarios": _vm.openResultadoExportacaoDestinatarios
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "inputImportacaoSecundaria",
    attrs: {
      "type": "file",
      "accept": ".csv"
    },
    on: {
      "change": _vm.importacaoSecundaria
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.isLeilaoPreparado) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-2"
  }, [_c('h4', [_vm._v("Lotes "), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.filteredDataLotes && _vm.filteredDataLotes.length))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-10"
  }, [(!_vm.isRestritoVisitante) ? _c('u-button', {
    staticClass: "btn btn-sm btn-success pull-right hidden-print m-b-sm",
    on: {
      "click": _vm.cadastraLote
    }
  }, [_vm._v("\n                  Cadastrar Lote\n                ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pull-right w-md m-r-sm"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterKey),
      expression: "filterKey"
    }],
    staticClass: "input-sm form-control hidden-print",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisar"
    },
    domProps: {
      "value": (_vm.filterKey)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterKey = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.filterKey) ? _c('span', {
    staticClass: "visible-print"
  }, [_vm._v("Filtro: " + _vm._s(_vm.filterKey))]) : _vm._e()]), _vm._v(" "), _c('u-button-group', {
    staticClass: "pull-right m-r",
    attrs: {
      "options": _vm.tiposLote
    },
    model: {
      value: (_vm.filtro.tipo),
      callback: function($$v) {
        _vm.$set(_vm.filtro, "tipo", $$v)
      },
      expression: "filtro.tipo"
    }
  }), _vm._v(" "), _c('filtro-status-lotes', {
    staticClass: "pull-right m-r",
    attrs: {
      "options": _vm.situacaoLote
    },
    model: {
      value: (_vm.filtro.situacao),
      callback: function($$v) {
        _vm.$set(_vm.filtro, "situacao", $$v)
      },
      expression: "filtro.situacao"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.isLeilaoPreparado) ? _c('table', {
    staticClass: "table-lotes-leilao table table-clicked bg-white b-a"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "hidden-print",
    staticStyle: {
      "width": "10px"
    }
  }, [_c('label', {
    staticClass: "i-checks m-b-none"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedAll),
      expression: "checkedAll"
    }],
    attrs: {
      "type": "checkbox",
      "tabindex": "0",
      "aria-checked": "false",
      "aria-invalid": "false"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkedAll) ? _vm._i(_vm.checkedAll, null) > -1 : (_vm.checkedAll)
    },
    on: {
      "click": _vm.checkAllLotes,
      "change": function($event) {
        var $$a = _vm.checkedAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkedAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkedAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkedAll = $$c
        }
      }
    }
  }), _c('i')])]), _vm._v(" "), _c('th', {
    staticClass: "text-nowrap",
    class: {
      active: _vm.sortKey === 'numero'
    },
    staticStyle: {
      "width": "30px"
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('numero')
      }
    }
  }, [_vm._v("\n                  LT "), _c('i', {
    staticClass: "fa",
    class: _vm.sortOrders['numero'] > 0 ? 'fa-caret-down' : 'fa-caret-up',
    staticStyle: {
      "font-size": "10px"
    }
  })]), _vm._v(" "), _c('th', {
    staticClass: "text-nowrap",
    class: {
      active: _vm.sortKey === 'grvNumero'
    },
    staticStyle: {
      "width": "40px"
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('grvNumero')
      }
    }
  }, [_vm._v("\n                  GRV "), _c('i', {
    staticClass: "fa",
    class: _vm.sortOrders['grvNumero'] > 0 ? 'fa-caret-down' : 'fa-caret-up',
    staticStyle: {
      "font-size": "10px"
    }
  })]), _vm._v(" "), _c('th', {
    staticClass: "hidden-print"
  }), _vm._v(" "), _c('th', {
    staticClass: "text-nowrap",
    class: {
      active: _vm.sortKey === 'titulo'
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('titulo')
      }
    }
  }, [_vm._v("\n                  DESCRIÇÃO "), _c('i', {
    staticClass: "fa",
    class: _vm.sortOrders['titulo'] > 0 ? 'fa-caret-down' : 'fa-caret-up',
    staticStyle: {
      "font-size": "10px"
    }
  })]), _vm._v(" "), _c('th', {
    staticClass: "text-nowrap",
    class: {
      active: _vm.sortKey === 'patio'
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('patio')
      }
    }
  }, [_vm._v("\n                  PÁTIO "), _c('i', {
    staticClass: "fa",
    class: _vm.sortOrders['patio'] > 0 ? 'fa-caret-down' : 'fa-caret-up',
    staticStyle: {
      "font-size": "10px"
    }
  })]), _vm._v(" "), _c('th', {
    staticClass: "text-nowrap",
    class: {
      active: _vm.sortKey === 'placa'
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('placa')
      }
    }
  }, [_vm._v("\n                  PLACA "), _c('i', {
    staticClass: "fa",
    class: _vm.sortOrders['placa'] > 0 ? 'fa-caret-down' : 'fa-caret-up',
    staticStyle: {
      "font-size": "10px"
    }
  })]), _vm._v(" "), _c('th', {
    staticClass: "text-nowrap",
    class: {
      active: _vm.sortKey === 'comitente'
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('comitente')
      }
    }
  }, [_vm._v("\n                  COMITENTE "), _c('i', {
    staticClass: "fa",
    class: _vm.sortOrders['comitente'] > 0 ? 'fa-caret-down' : 'fa-caret-up',
    staticStyle: {
      "font-size": "10px"
    }
  })]), _vm._v(" "), _c('th', {
    staticClass: "text-nowrap",
    staticStyle: {
      "width": "120px"
    }
  }, [_vm._v("MÍNIMO")]), _vm._v(" "), _c('th', {
    staticClass: "text-nowrap",
    staticStyle: {
      "width": "120px"
    }
  }, [_vm._v("LANCE ATUAL")]), _vm._v(" "), _c('th', {
    staticClass: "text-nowrap",
    staticStyle: {
      "width": "120px"
    }
  }, [_vm._v("ARREMATE")]), _vm._v(" "), _c('th', {
    staticClass: "text-nowrap",
    staticStyle: {
      "width": "120px"
    }
  }, [_vm._v("VALOR TOTAL")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.filteredDataLotes), function(lote) {
    return _c('tr', {
      staticClass: "leilao-list-lote-item",
      class: _vm.bindClassLoteList(lote)
    }, [_c('td', {
      staticClass: "hidden-print",
      class: {
        'alert-danger': lote.status === _vm.STATUS_RETIRADO
      }
    }, [_c('label', {
      staticClass: "i-checks m-b-none"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (lote.checked),
        expression: "lote.checked"
      }],
      attrs: {
        "type": "checkbox",
        "tabindex": "0",
        "aria-checked": "false",
        "aria-invalid": "false"
      },
      domProps: {
        "checked": Array.isArray(lote.checked) ? _vm._i(lote.checked, null) > -1 : (lote.checked)
      },
      on: {
        "click": function($event) {
          return _vm.checkLote(lote)
        },
        "change": function($event) {
          var $$a = lote.checked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(lote, "checked", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(lote, "checked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(lote, "checked", $$c)
          }
        }
      }
    }), _c('i')])]), _vm._v(" "), _c('td', {
      class: {
        'alert-danger': lote.status === _vm.STATUS_RETIRADO
      }
    }, [_vm._v(_vm._s(lote.numero))]), _vm._v(" "), _c('td', {
      class: {
        'alert-danger': lote.status === _vm.STATUS_RETIRADO
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: _vm.urlGrv,
          params: {
            id: lote.grvId
          }
        },
        "target": "_blank",
        "replace": ""
      }
    }, [_c('u', [_vm._v(_vm._s(lote.grvNumero || '-'))])]), _vm._v(" "), _c('br'), _vm._v(" "), (lote.bloqueadoParaLeilao) ? _c('span', {
      staticClass: "text-danger small"
    }, [_vm._v("GRV bloqueada para leilão")]) : _vm._e()], 1), _vm._v(" "), _c('td', {
      staticClass: "hidden-print",
      class: {
        'alert-danger': lote.status === _vm.STATUS_RETIRADO
      }
    }, [(lote.status === _vm.STATUS_RETIRADO) ? _c('img', {
      attrs: {
        "width": "50",
        "src": require("../assets/lote-retirado.jpg"),
        "loading": "lazy"
      }
    }) : _c('img', {
      attrs: {
        "width": "50",
        "src": lote.urlMin,
        "loading": "lazy"
      }
    })]), _vm._v(" "), _c('td', {
      class: {
        'alert-danger': lote.status === _vm.STATUS_RETIRADO
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'lotes.visualizar',
          params: {
            leilao: _vm.leilao.id,
            id: lote.id
          }
        }
      }
    }, [_vm._v(_vm._s(lote.titulo.toUpperCase()) + "\n                  ")])], 1), _vm._v(" "), _c('td', {
      class: {
        'alert-danger': lote.status === _vm.STATUS_RETIRADO
      }
    }, [_vm._v(_vm._s(lote.patioNome))]), _vm._v(" "), _c('td', {
      class: {
        'alert-danger': lote.status === _vm.STATUS_RETIRADO
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'lotes.visualizar',
          params: {
            leilao: _vm.leilao.id,
            id: lote.id
          }
        }
      }
    }, [_vm._v(_vm._s(lote.placa && lote.placa.toUpperCase()) + "\n                  ")])], 1), _vm._v(" "), _c('td', {
      class: {
        'alert-danger': lote.status === _vm.STATUS_RETIRADO
      }
    }, [_vm._v(_vm._s(lote.comitente ? lote.comitente : 'Sem comitente'))]), _vm._v(" "), _c('td', {
      class: {
        'alert-danger': lote.status === _vm.STATUS_RETIRADO
      }
    }, [_vm._v("R$ " + _vm._s(_vm._f("moeda")(lote.valorMinimo)))]), _vm._v(" "), _c('td', {
      staticClass: "text-nowrap",
      class: {
        'alert-danger': lote.status === _vm.STATUS_RETIRADO
      }
    }, [_vm._v("R$ " + _vm._s(_vm._f("moeda")(lote.ultimoLanceValor)) + "\n                  "), (lote.ultimoLanceApelido && lote.ultimoLanceApelido === 'PLATEIA') ? _c('span', {
      staticClass: "label label-xs no-radius bg-white",
      attrs: {
        "title": "Plateia"
      }
    }, [_vm._v("P\n                    "), (lote.boleta) ? _c('span', {
      staticStyle: {
        "color": "gray"
      }
    }, [_vm._v(" (Boleta "), _c('span', {
      staticStyle: {
        "font-size": "14px"
      }
    }, [_vm._v(_vm._s(lote.boleta))]), _vm._v(")")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (lote.ultimoLanceApelido && lote.ultimoLanceApelido !== 'PLATEIA') ? _c('span', {
      staticClass: "label label-xs no-radius bg-white text-success"
    }, [_vm._v(_vm._s(lote.ultimoLanceApelido) + "\n                    "), (lote.status === 6) ? _c('button', {
      staticClass: "btn btn-xs m-l-xs",
      on: {
        "click": function($event) {
          return _vm.$refs.cobrancaView.load(_vm.leilao.id, lote.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-envelope-o",
      attrs: {
        "title": "Gerar Cobrança"
      }
    })]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('td', {
      class: {
        'alert-danger': lote.status === _vm.STATUS_RETIRADO
      }
    }, [_vm._v("R$ " + _vm._s(_vm._f("moeda")(lote.valorArremate)))]), _vm._v(" "), _c('td', {
      class: {
        'alert-danger': lote.status === _vm.STATUS_RETIRADO
      }
    }, [_vm._v("R$ " + _vm._s(_vm._f("moeda")((lote.valorComTaxas || 0.00))))])])
  }), _vm._v(" "), (_vm.ACL.check('visualizar_valores_leilao', _vm.currentUser.id)) ? _c('tr', [_c('td', {
    staticClass: "hidden-print"
  }), _vm._v(" "), _c('td', {
    staticClass: "hidden-print"
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "hidden-print"
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_c('strong', [_vm._v("Subtotal")])]), _vm._v(" "), _c('td', [_vm._v("R$ " + _vm._s(_vm._f("moeda")(_vm.subTotalMinimo)))]), _vm._v(" "), _c('td', [_vm._v("R$ " + _vm._s(_vm._f("moeda")(_vm.subTotalLances)))]), _vm._v(" "), _c('td', [_vm._v("R$ " + _vm._s(_vm._f("moeda")(_vm.subTotalArremate)))]), _vm._v(" "), _c('td', [_vm._v("R$ " + _vm._s(_vm._f("moeda")(_vm.subTotalArremateComTaxas)))])]) : _vm._e(), _vm._v(" "), (_vm.leilao.cobraComissao) ? _c('tr', [_c('td', {
    staticClass: "hidden-print"
  }), _vm._v(" "), _c('td', {
    staticClass: "hidden-print"
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "hidden-print"
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "text-right no-border"
  }, [_c('strong', [_vm._v("Comissão " + _vm._s(_vm.leilao.comissao) + "%")])]), _vm._v(" "), _c('td', [_vm._v("R$ " + _vm._s(_vm._f("moeda")(_vm.comissaoMinimo)))]), _vm._v(" "), _c('td', [_vm._v("R$ " + _vm._s(_vm._f("moeda")(_vm.comissaoLances)))]), _vm._v(" "), _c('td', [_vm._v("R$ " + _vm._s(_vm._f("moeda")(_vm.comissaoArremate)))])]) : _vm._e(), _vm._v(" "), (_vm.leilao.cobraTaxasAdicionais) ? _c('tr', [_c('td', {
    staticClass: "hidden-print"
  }), _vm._v(" "), _c('td', {
    staticClass: "hidden-print"
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "hidden-print"
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "text-right no-border"
  }, [_c('strong', [_vm._v("Taxa ICMS " + _vm._s(_vm.leilao.taxaIcms) + "%")])]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("-")])]) : _vm._e(), _vm._v(" "), (_vm.leilao.cobraTaxasAdicionais) ? _c('tr', [_c('td', {
    staticClass: "hidden-print"
  }), _vm._v(" "), _c('td', {
    staticClass: "hidden-print"
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "hidden-print"
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "text-right no-border"
  }, [_c('strong', [_vm._v("Taxa ISS " + _vm._s(_vm.leilao.taxaIss) + "%")])]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("-")])]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.lotesChecked.length > 0 && _vm.leilao.lotes.length) ? _c('div', {
    staticClass: "m-t-n m-b-lg"
  }, [_vm._v("\n              Ação para selecionados:\n              "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.actionCheckedLotes),
      expression: "actionCheckedLotes"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.actionCheckedLotes = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm._actionCheckedLotes]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Selecione a ação")]), _vm._v(" "), (_vm.ACL.check('deletar_lote_leilao', _vm.currentUser.id)) ? _c('option', {
    attrs: {
      "value": "deletar"
    }
  }, [_vm._v("Excluir")]) : _vm._e(), _vm._v(" "), _c('option', {
    attrs: {
      "value": "copiar"
    }
  }, [_vm._v("Copiar para outro leilão")])])]) : _vm._e(), _vm._v(" "), (_vm.isLeilaoPreparado) ? _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.leilao.comitentes), function(comitente) {
    return _c('div', {
      staticClass: "col-xs-4"
    }, [_c('div', {
      staticClass: "panel b-light clearfix"
    }, [_c('div', {
      staticClass: "panel-body"
    }, [_c('a', {
      staticClass: "pull-left m-r"
    }, [_c('img', {
      attrs: {
        "src": comitente.imagem,
        "width": "100"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "clear"
    }, [_c('a', {
      staticClass: "text-dark"
    }, [_vm._v(_vm._s(comitente.nome))]), _vm._v(" "), _c('small', {
      staticClass: "block text-muted"
    }, [_vm._v(_vm._s(comitente.lotes) + " lote" + _vm._s(comitente.lotes > 1 ? 's' : '') + "\n                      ")])])])])])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('h4', [_vm._v("Documentos públicos")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('u-button', {
    staticClass: "btn btn-sm btn-default fileContainer pull-right hidden-print m-b-sm"
  }, [_vm._v("\n                  Cadastrar Documento\n                  "), _c('input', {
    ref: "fileDocumento",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.uploadDocumento
    }
  })])], 1)]), _vm._v(" "), _c('table', {
    staticClass: "table table-clicked table-striped bg-white b-a"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("DOCUMENTO")]), _vm._v(" "), _c('th', [_vm._v("ARQUIVO")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "100px"
    }
  })])]), _vm._v(" "), _c('tbody', _vm._l((_vm.leilao.documentos), function(documento) {
    return _c('tr', {
      attrs: {
        "id": 'documento' + documento.id
      }
    }, [_c('td', [_vm._v(_vm._s(documento.nome))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": documento.urlStorage,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(documento.arquivo))])]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "text-danger",
      on: {
        "click": function($event) {
          return _vm.removeDocumento(documento.id)
        }
      }
    }, [_vm._v("Remover")])])])
  }), 0)])]), _vm._v(" "), _c('u-button', {
    staticClass: "btn btn-sm btn-default hidden-print",
    attrs: {
      "tabindex": "1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.renovarCache($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-hdd-o m-r-xs"
  }), _vm._v(" Renovar Cache\n          ")])], 1)])], 1) : _vm._e()]), _vm._v(" "), (_vm.showResultadosGeracaoLotes) ? _c('popup-viewer', {
    attrs: {
      "title": ("Resultados da geração de lotes para o leilão " + (_vm.leilao.titulo))
    },
    on: {
      "close": _vm.closeResultadoGeracaoLotes
    }
  }, [_c('ResultadoGeracaoLotesLeilao', {
    attrs: {
      "quantidadeDeGrvsSelecionadas": _vm.leilao.quantidadeDeGrvsSelecionadas,
      "lotesNaoGerados": _vm.leilao.lotesNaoGerados
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showRelatorioPreparacaoLeilaoViewer) ? _c('popup-viewer', {
    attrs: {
      "title": _vm.relatioPreparacaoLeilaoViewerProps.titulo
    },
    on: {
      "close": _vm.closeResultadoImportacaoCsvGrv
    }
  }, [_c('HistoricoLogsImportacaoPreparacaoLeilao', {
    attrs: {
      "leilaoId": _vm.leilao.id,
      "tipoLog": _vm.relatioPreparacaoLeilaoViewerProps.tipoRelatorio
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showResultadosDestinatarios) ? _c('popup-viewer', {
    attrs: {
      "title": ("Resultados dos destinatários do leilão " + (_vm.leilao.titulo))
    },
    on: {
      "close": _vm.closeResultadoExportacaoDestinatarios
    }
  }, [_c('ResultadoDestinatarios', {
    attrs: {
      "total": _vm.entidades.total,
      "destinatariosErroCep": _vm.entidades.cepInvalido
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-861f6b30","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/leiloes/components/VisualizarLeilao.vue
// module id = 1804
// module chunks = 17